<template>
  <v-btn
    v-if="item[header.value]"
    text
    :href="`${ isAppLink ? appUrl : '' }/${ header.path ? header.path : ''}${ item[header.value] }`"
    target="_blank"
    light
    color="primary"
    class="text-capitalize"
  >
    {{ header.label }}
  </v-btn>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UrlContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  },
  computed: { ...mapState(['appUrl']) },
  methods: {
    isAppLink () {
      return ('isAppLink' in this.header) ? this.header.isAppLink : true;
    }
  }
};
</script>
